import { render, staticRenderFns } from "./FormPage.vue?vue&type=template&id=7bc40476&scoped=true&"
import script from "./FormPage.vue?vue&type=script&lang=js&"
export * from "./FormPage.vue?vue&type=script&lang=js&"
import style0 from "./FormPage.vue?vue&type=style&index=0&id=7bc40476&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../.jenkins/workspace/DMSDashboardDeployLIVE/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc40476",
  null
  
)

export default component.exports